import { render } from "./headerPage.vue?vue&type=template&id=252543ff"
import script from "./headerPage.vue?vue&type=script&lang=js"
export * from "./headerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__